import { FilterTableConfig } from 'AppConfig/TableConfig/Filter';

// Filter.ResultsProcessStatementTable.Answered
const parseExpression = (input) => {
  const PREFIX = 'Filter.';

  if (!input.startsWith(PREFIX)) {
    return undefined;
  }

  const path = input.slice(PREFIX.length).split('.');
  if(!(path || []).length) {
    return undefined;
  }

  return path.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : null, FilterTableConfig);
}

export const getCustomFilters = (path, customProps = {}) => {
  const filterFunction = parseExpression(path);
  if(!filterFunction) {
    return undefined;
  }

  return filterFunction({ props: customProps });
}
